import type { OptimizedPositionSet } from "connected-components/optimize-experiments/hooks/types"
import { getOptimizationResultName } from "./configuration"

export function buildLabeledOptimizationComparisonInstrument(
  optimizedPositionSet: OptimizedPositionSet,
  sourceInstrumentType: string | undefined,
  optimizationResultExperimentName: string | null | undefined,
): OptimizedPositionSet & { isOptimization: true, name: string | undefined } {
  return {
    ...optimizedPositionSet,
    isOptimization: true,
    name: getOptimizationResultName(sourceInstrumentType, optimizationResultExperimentName),
  }
}

export function markOptimizedPositionSetIfNew<T extends OptimizedPositionSet>(
  lastLabeledRef: { current: T | null },
  optimizedPositionSet: T,
): boolean {
  if (lastLabeledRef.current === optimizedPositionSet) {
    return false
  }
  lastLabeledRef.current = optimizedPositionSet
  return true
}
